<div class="ax-panel">
  <app-chart (pointClickedEvt)="pointClickedHandler($event)"
             [clickable]="true">
  </app-chart>
</div>
